import axios from 'axios';
import { API_BASE_URL } from './url_config';

export const fetchTopNotification = async () => {
  return await axios.get(`${API_BASE_URL}/notification/get-top`, { });
};

export const fetchBottomNotification = async () => {
  return await axios.get(`${API_BASE_URL}/notification/get-bottom`, { });
};